import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableComponent from "../../components/table/TableComponent";
import { Column } from "../../interfaces/table.interface";
import { get } from "../../redux/ApiHelper";
import { RootState } from "../../redux/store";
import { ShadowWalletInterface } from "../../interfaces/shadow-wallet.interface";
import { startLoading, stopLoading } from "../../redux/slices/WindowSlice";

const TeacherShadowWallet = () => {
  const [wallets, setWallets] = useState<ShadowWalletInterface[]>([]);
  const [filteredWallets, setFilteredWallets] = useState<
    ShadowWalletInterface[]
  >([]);
  const { signedAdmin } = useSelector((state: RootState) => state.admin);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const dispatch = useDispatch();
  //   const { signedAdmin } = useSelector((state: RootState) => state.admin);

  // Fetch tuition job posts on component mount
  useEffect(() => {
    // const queryParams = new URLSearchParams();
    // queryParams.set("type", String(signedAdmin.type));
    // queryParams.set("adminId", String(signedAdmin.id));
    dispatch(startLoading());
    get(`/admin/shadow-wallet/getAll`)
      .then((res) => {
        setWallets(res);
        setFilteredWallets(res);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        dispatch(stopLoading());
      });
  }, []);

  // Search functionality
  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const lowerQuery = query.toLowerCase();

    const filteredList = wallets.filter((pkg) => {
      const tuitionRequest = typeof pkg.tuitionRequestId === 'object' ? pkg.tuitionRequestId : null;
      if (!tuitionRequest) return false;

      return (
        tuitionRequest.parent?._id?.toLowerCase().includes(lowerQuery) ||
        tuitionRequest.parent?.name?.toLowerCase().includes(lowerQuery) ||
        tuitionRequest.parent?.email?.toLowerCase().includes(lowerQuery) ||
        tuitionRequest.parent?.phoneNumber?.toString().includes(lowerQuery) ||
        tuitionRequest.preferredTeacher?._id?.toLowerCase().includes(lowerQuery) ||
        tuitionRequest.preferredTeacher?.name?.toLowerCase().includes(lowerQuery) ||
        tuitionRequest.preferredTeacher?.email?.toLowerCase().includes(lowerQuery) ||
        tuitionRequest.preferredTeacher?.phoneNumber?.toString().includes(lowerQuery) ||
        tuitionRequest.student?.name?.toLowerCase().includes(lowerQuery) ||
        tuitionRequest.student?._id?.toLowerCase().includes(lowerQuery)
      );
    });

    setFilteredWallets(filteredList);
  };

  const columns: Column[] = [
    {
      select: "tuitionRequestId",
      header: "Teacher name",
      render: (_value: any, row: ShadowWalletInterface) => {
        const tuitionRequest = typeof row.tuitionRequestId === 'object' ? row.tuitionRequestId : null;
        return tuitionRequest?.preferredTeacher?.name || "N/A";
      },
    },
    {
      select: "tuitionRequestId",
      header: "Teacher phone number",
      render: (_value: any, row: ShadowWalletInterface) => {
        const tuitionRequest = typeof row.tuitionRequestId === 'object' ? row.tuitionRequestId : null;
        return tuitionRequest?.preferredTeacher?.phoneNumber || "N/A";
      },
    },
    {
      select: "tuitionRequestId",
      header: "Teacher email",
      render: (_value: any, row: ShadowWalletInterface) => {
        const tuitionRequest = typeof row.tuitionRequestId === 'object' ? row.tuitionRequestId : null;
        return tuitionRequest?.preferredTeacher?.email || "N/A";
      },
    },
    {
      header: "Parent Name",
      render: (_value: any, row: ShadowWalletInterface) => {
        const tuitionRequest = typeof row.tuitionRequestId === 'object' ? row.tuitionRequestId : null;
        return tuitionRequest?.parent?.name || "N/A";
      },
    },
    {
      select: "tuitionRequestId",
      header: "Student name",
      render: (_value: any, row: ShadowWalletInterface) => {
        const tuitionRequest = typeof row.tuitionRequestId === 'object' ? row.tuitionRequestId : null;
        return tuitionRequest?.student?.name || "N/A";
      },
    },
    { select: "coins", header: "coins" },
    { select: "availableSecurityCoins", header: "Security coins" },
    { select: "teachedHours", header: "Teached hours" },
    { select: "availableBonus", header: "Available Bonus" },
  ];

  return (
    <div className="tuitionJobPosts table-container">
      <div className="title">Teacher shadow wallets</div>
      <div className="search-container mb-4">
        <input
          type="text"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-700"
          placeholder="Search by id, parent"
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>

      <TableComponent
        columns={columns.filter((item) => {
          if (
            signedAdmin.type === "franchise" &&
            (item.header === "Teacher email" ||
              item.header === "Teacher phone number")
          ) {
            return false;
          } else {
            return true;
          }
        })}
        data={filteredWallets}
      />
    </div>
  );
};

export default TeacherShadowWallet;
